var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgMetabotFailure = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 96,
  height: 96,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#a)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 48,
  cy: 48,
  r: 48,
  fill: "#4C5773",
  fillOpacity: 0.05
}), /*#__PURE__*/React.createElement("path", {
  d: "M24 35a4 4 0 0 1 4-4h40a4 4 0 0 1 4 4v26a4 4 0 0 1-4 4H28a4 4 0 0 1-4-4V35Z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M23.375 35A4.625 4.625 0 0 1 28 30.375h40A4.625 4.625 0 0 1 72.625 35v26A4.625 4.625 0 0 1 68 65.625H28A4.625 4.625 0 0 1 23.375 61V35ZM28 31.625A3.375 3.375 0 0 0 24.625 35v26A3.375 3.375 0 0 0 28 64.375h40A3.375 3.375 0 0 0 71.375 61V35A3.375 3.375 0 0 0 68 31.625H28Z",
  fill: "#949AAB"
}), /*#__PURE__*/React.createElement("path", {
  d: "M29.5 38a1.5 1.5 0 0 1 1.5-1.5h34a1.5 1.5 0 0 1 1.5 1.5v17a1.5 1.5 0 0 1-1.5 1.5H31a1.5 1.5 0 0 1-1.5-1.5V38Z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M28.875 38c0-1.174.951-2.125 2.125-2.125h34c1.174 0 2.125.951 2.125 2.125v17A2.125 2.125 0 0 1 65 57.125H31A2.125 2.125 0 0 1 28.875 55V38ZM31 37.125a.875.875 0 0 0-.875.875v17c0 .483.392.875.875.875h34a.875.875 0 0 0 .875-.875V38a.875.875 0 0 0-.875-.875H31ZM61.071 61.179a.464.464 0 1 0 0-.93.464.464 0 0 0 0 .93Zm0 1.25a1.714 1.714 0 1 0 0-3.429 1.714 1.714 0 0 0 0 3.429ZM65.571 61.179a.464.464 0 1 0 0-.93.464.464 0 0 0 0 .93Zm0 1.25a1.714 1.714 0 1 0 0-3.429 1.714 1.714 0 0 0 0 3.429Z",
  fill: "#949AAB"
}), /*#__PURE__*/React.createElement("path", {
  d: "M39.5 42 L42.5 45 M42.5 42 L39.5 45",
  stroke: "#949AAB",
  strokeWidth: 1.25,
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M53.5 42 L56.5 45 M56.5 42 L53.5 45",
  stroke: "#949AAB",
  strokeWidth: 1.25,
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M44 49 Q45.5 47.5 47 49 T50 49 T53 49",
  stroke: "#949AAB",
  strokeWidth: 1.25,
  strokeLinecap: "round"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h96v96H0z"
})))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgMetabotFailure);
export default ForwardRef;